const COLORES_BG = {
  verde: "#d4edda",
  amarillo: "#fff3cd",
  rojo: "#f8d7da",
};

const COLOR_PRIORIDAD = { rojo: 3, amarillo: 2, verde: 1 };

const peorColor = (colores) => {
  if (colores.length === 0) return "rojo";
  return colores.reduce((peor, c) => (COLOR_PRIORIDAD[c] > COLOR_PRIORIDAD[peor] ? c : peor), "verde");
};

const BORDER = "1px solid #999";

const WB = "break-word";

const ContactoCell = ({ contacto, emptyColor }) => {
  if (!contacto) {
    return <td style={{ border: BORDER, backgroundColor: COLORES_BG[emptyColor], textAlign: "left" }} />;
  }
  return (
    <td
      style={{
        backgroundColor: COLORES_BG[contacto.color],
        border: BORDER,
        fontSize: ".8rem",
        textAlign: "left",
        overflowWrap: WB,
      }}
    >
      {contacto.nombre} {contacto.apellido}
    </td>
  );
};

const GRIS_BG = "#e9ecef";

const FilaCliente = ({ cli, categoriaCell, subcategoriaCell, marcaCell, maxContactos, productoEsEmpresa }) => {
  const agencia = cli.contactosAgencia;
  const cliente = cli.contactosCliente;
  const esDirecto = cli.agenciaNombre === "Directo";

  const colorAgencia = peorColor(agencia.map((c) => c.color));
  const colorCliente = peorColor(cliente.map((c) => c.color));

  const emptyAgencia = agencia.length > 0 ? colorAgencia : "rojo";
  const emptyCliente = cliente.length > 0 ? colorCliente : "rojo";

  const bgAgenciaLabel = esDirecto ? GRIS_BG : COLORES_BG[colorAgencia];

  return (
    <>
      <tr>
        {categoriaCell}
        {subcategoriaCell}
        {marcaCell}
        {!productoEsEmpresa && (
          <td
            rowSpan={2}
            style={{ border: BORDER, backgroundColor: COLORES_BG[cli.color], textAlign: "left", overflowWrap: WB }}
            className="align-middle small"
          >
            {cli.producto || cli.empresa}
          </td>
        )}
        <td
          style={{
            border: BORDER,
            backgroundColor: bgAgenciaLabel,
            textAlign: "left",
            overflowWrap: WB,
            wordBreak: WB,
          }}
          className="small"
        >
          {cli.agenciaNombre}
        </td>
        {Array.from({ length: maxContactos }, (_, i) =>
          esDirecto && !agencia[i] ? (
            <td key={i} style={{ border: BORDER, backgroundColor: GRIS_BG, textAlign: "left" }} />
          ) : (
            <ContactoCell key={i} contacto={agencia[i]} emptyColor={esDirecto ? null : emptyAgencia} />
          )
        )}
      </tr>
      <tr>
        <td
          style={{
            border: BORDER,
            backgroundColor: COLORES_BG[colorCliente],
            whiteSpace: "nowrap",
            textAlign: "left",
          }}
          className="small"
        >
          Cliente
        </td>
        {Array.from({ length: maxContactos }, (_, i) => (
          <ContactoCell key={i} contacto={cliente[i]} emptyColor={emptyCliente} />
        ))}
      </tr>
    </>
  );
};

export default FilaCliente;
